import createSliders from '../../global/create-swiper-sliders';

function getSliderId(slider) {

    return slider.el.getAttribute('data-slider-id');
}

function getSlideSelectorButtons(sliderId) {

    return [...document.querySelectorAll(`[data-slide-selector-button-for-slider="${sliderId}"]`)];
}

function getSlideIndex(button) {
    const slideIndexAttribute = button.getAttribute('data-slide-index');
    
    return parseInt(slideIndexAttribute);
}

function selectSlide(button, slider) {
    const slideIndex = getSlideIndex(button);

    slider.selectedIndex = slideIndex;
    slider.slideTo(slideIndex);
    slider.forceSelect = true;
    highlightActiveSlideSelectorButton(slider);
    highlightActiveSlide(slider);
    slider.forceSelect = false;
}

function getSlideDates(slider) {

    return [...slider.el.querySelectorAll('.js_aboutTimelineVideo__date')];
}

function highlightActiveSlide(slider) {
    const dates = getSlideDates(slider);;
    let selectedIndex;

    if (slider.forceSelect) {
        selectedIndex = slider.selectedIndex;
    } else {
        selectedIndex = slider.realIndex;
    }
    
    dates.filter(date => getSlideIndex(date) == selectedIndex).forEach(date => date.classList.add('aboutTimelineVideo__date--active'));

    dates.filter(date => getSlideIndex(date) != selectedIndex).forEach(date => date.classList.remove('aboutTimelineVideo__date--active'));
}

function highlightActiveSlideSelectorButton(slider) {
    const sliderId = getSliderId(slider);
    const slideSelectorButtons = getSlideSelectorButtons(sliderId);
    let selectedIndex;

    if (slider.forceSelect) {
        selectedIndex = slider.selectedIndex;
    } else {
        selectedIndex = slider.realIndex;
    }
    
    slideSelectorButtons.filter(button => getSlideIndex(button) == selectedIndex).forEach(button => button.classList.add('aboutTimeline__navButton--active'));
    slideSelectorButtons.filter(button => getSlideIndex(button) != selectedIndex).forEach(button => button.classList.remove('aboutTimeline__navButton--active'));
}

function scrollElementHorizontallyIntoView(el) {
    const parent = el.parentElement;
    const isVisible = (el.offsetLeft - parent.scrollLeft) >= 0 && (el.offsetLeft + el.offsetWidth) <= parent.offsetWidth;

    if (!isVisible) {
        parent.scrollLeft = el.offsetLeft;
    }
}

function scrollActiveSlideSelectorButtonIntoView(slider) {
    const sliderId = getSliderId(slider);
    const slideSelectorButtons = getSlideSelectorButtons(sliderId);
    let selectedIndex;

    if (slider.forceSelect) {
        selectedIndex = slider.selectedIndex;
    } else {
        selectedIndex = slider.realIndex;
    }

    const button = slideSelectorButtons.find(btn => getSlideIndex(btn) == selectedIndex);

    if (button) {
        scrollElementHorizontallyIntoView(button);
    }
}

function initSlideSelectorButtonNavigation(slider) {
    const sliderId = getSliderId(slider);
    const slideSelectorButtons = getSlideSelectorButtons(sliderId);

    slider.forceSelect = false;
    
    slideSelectorButtons.forEach(button => button.addEventListener('click', e => selectSlide(button, slider)));

    slider.on('slideChange', slider => {
        highlightActiveSlideSelectorButton(slider);
        highlightActiveSlide(slider);
        scrollActiveSlideSelectorButtonIntoView(slider);
    });
}

function init() {
    const options = {
        slidesPerView: 'auto',
        watchOverflow: true,
        watchSlidesProgress: true,
        freeMode: false,
        spaceBetween: 30,
    };

    const sliders = createSliders('js_aboutTimeline__videos', options);
    sliders.forEach(initSlideSelectorButtonNavigation);
    sliders.forEach(highlightActiveSlideSelectorButton);
    sliders.forEach(highlightActiveSlide);
    sliders.forEach(scrollActiveSlideSelectorButtonIntoView);
}

$(document).ready(init);
